import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-alerta_662b48af4d7ab93624bdd2d6a2eece69",
  "use": "ic-alerta_662b48af4d7ab93624bdd2d6a2eece69-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-alerta_662b48af4d7ab93624bdd2d6a2eece69\">\n    <path fill-rule=\"nonzero\" d=\"M22 19.75v-5c0-3.07-1.64-5.64-4.5-6.32v-.68a1.5 1.5 0 0 0-3 0v.68c-2.87.68-4.5 3.24-4.5 6.32v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2v-4h2v4zm-1 10a2.006 2.006 0 0 0 2-2h-4a2 2 0 0 0 2 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id